class ScrollTrack extends HTMLElement {
    constructor() {
      super();
  
      this.maxScroll = 0;
      this.currentScroll = 0;
  
      this.btnPrev = this.querySelector("[data-prev]");
      this.btnNext = this.querySelector("[data-next]");
  
      this.slide = this.querySelector("[data-slide]");
      this.item = this.querySelector("[data-item]");
  
      this.init();
      this.setupMutationObserver();
    }
  
    init() {
      this.maxScroll =
        Number(this.slide.scrollWidth) - Number(this.slide.clientWidth);
  
      this.btnPrev.addEventListener("click", this.prevStep.bind(this));
      this.btnNext.addEventListener("click", this.nextStep.bind(this));
    }
  
    nextStep() {
      this.currentScroll += this.item.offsetWidth;
  
      if (this.maxScroll >= this.currentScroll) {
        this.slide.scrollTo(this.currentScroll, 0);
      } else {
        this.currentScroll = 0;
        this.slide.scrollTo(0, 0);
      }
    }
  
    prevStep() {
      this.currentScroll -= this.item.offsetWidth;
  
      if (this.currentScroll >= 0) {
        this.slide.scrollTo(this.currentScroll, 0);
      } else {
        this.currentScroll = this.maxScroll;
        this.slide.scrollTo(this.maxScroll, 0);
      }
    }
  
    recalculate() {
      this.maxScroll =
        Number(this.slide.scrollWidth) - Number(this.slide.clientWidth);
      this.currentScroll = 0;
      this.slide.scrollTo(0, 0);
      this.item = this.querySelector("[data-item]");
    }
  
    setupMutationObserver() {
      const observer = new MutationObserver(() => {
        this.recalculate();
      });
  
      const config = { childList: true };
  
      observer.observe(this.slide, config);
    }
}
  
customElements.define("scroll-track", ScrollTrack);

class ToggleModalSize extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.toggleModal.bind(this));
  }

  toggleModal(event) {
    event.preventDefault();
    event.stopPropagation();

    const currentTarget = event.currentTarget;

    if (currentTarget) {
      document.querySelector(".modal-size").classList.toggle("show-modal");
    }

    return;
  }
}

customElements.define("toggle-modal-size", ToggleModalSize);

$(document).ready(function(){
  
  var tela = $(window).width();

  $(".column-button").on("click",function(e){
    e.preventDefault();
  
    let largura = $(window).width();
    let classes = $('ul#product-grid').attr('class').split(/\s+/);
    let colunas = $(this).attr("column-division");
    
    classes.forEach( classe => {
      
      if( largura < 990 ){
  
        if( classe.includes("-col-tablet-down") ){
  
          let classeControl = classe.split("-");
          classeControl[2] = colunas;
          
          $('ul#product-grid').removeClass(classe);
          $('ul#product-grid').addClass(classeControl.join("-"));
  
          $(".column-button").removeClass("active");
          $(this).addClass("active");
  
        }
  
      }else{
  
        if( classe.includes("-col-desktop") ){
  
          let classeControl = classe.split("-");
          classeControl[2] = colunas;
          
          $('ul#product-grid').removeClass(classe);
          $('ul#product-grid').addClass(classeControl.join("-"));
  
          $(".column-button").removeClass("active");
          $(this).addClass("active");
  
        }
  
      }
  
    });
  });
  
  if(tela <= 990){
    $('.first-nest-link').on('click', function(e){
      e.preventDefault();

      $(this).find(".toggle-menu").toggleClass('opened');
      $(this).parent().find(".sub-links").slideToggle();

    });
  }
  
  product_init_utils();
  init_input_masks();

});


function init_input_masks(){
  $('.phone').mask('(00) 00000-0000');
  $('#ContactForm-phone').mask('(00) 00000-0000');
}

function product_init_utils(){

  $('.wishlist-engine').on('click', function() {
    let productHandle = $(this).data('product_handle');
    console.log(productHandle);

    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    // Verifica se o item já está na lista e o remove
    let index = wishlist.indexOf(productHandle);
    if (index > -1) {
        wishlist.splice(index, 1); // Remove o item se já existir
    } else {
        // Adiciona o item à lista, se não ultrapassar 16 registros
        if (wishlist.length < 16) {
            wishlist.push(productHandle);
        } else {
            alert("Você atingiu o limite máximo de 16 itens na lista.");
        }
    }

    // Atualiza o localStorage
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  });

}